import styled from 'styled-components';

export const BreadcrumbsStyled = styled.div`
  display: flex;
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  flex-wrap: wrap;
  align-items: center;
`;

export const BreadcrumbsItemStyled = styled.div`
  display: flex;
  padding-right: 24px;
  position: relative;
  min-height: 32px;
  align-items: center;
  word-break: break-word;

  &::after {
    content: '/';
    position: absolute;
    right: 10px;
    font-size: 14px;
    top: 5px;
    pointer-events: none;
  }
  &:last-of-type {
    padding-right: 8px;
  }
  &:last-of-type::after {
    display: none;
  }
`;
